var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFileCode = function SvgFileCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.333 9.457v17.21c0 2.334 0 3.5.455 4.392a4.167 4.167 0 0 0 1.82 1.82c.892.455 2.059.455 4.392.455h17.21M58.334 72.917 68.75 62.5 58.333 52.084m-16.666 0L31.25 62.5l10.417 10.417m41.666-31.3v30.05c0 7 0 10.5-1.362 13.175a12.5 12.5 0 0 1-5.463 5.462c-2.674 1.363-6.174 1.363-13.175 1.363H36.667c-7.001 0-10.501 0-13.175-1.363a12.5 12.5 0 0 1-5.463-5.462c-1.362-2.674-1.362-6.174-1.362-13.175V28.333c0-7 0-10.5 1.362-13.174a12.5 12.5 0 0 1 5.463-5.463c2.674-1.362 6.174-1.362 13.175-1.362h13.382c3.057 0 4.586 0 6.025.345a12.5 12.5 0 0 1 3.613 1.496c1.261.773 2.342 1.854 4.504 4.016l13.284 13.285c2.162 2.162 3.243 3.242 4.016 4.504a12.498 12.498 0 0 1 1.497 3.613c.345 1.439.345 2.967.345 6.025Z",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgFileCode;